// Save-state bus - mirrors the "no-state, DOM-controlled" pattern used by
// footnoteModalBus, yearEndModalBus, etc.
//
// Motivation: EditFilings.tsx renders 12k+ inputs for consolidated filings.
// Using useState for `isSaving` caused every save to schedule full-component
// re-renders, which back-to-back froze the main thread post-save.
// With this bus, the Save button subscribes to DOM events and updates its
// own disabled state + label via a ref - zero React re-renders.

let saving = false;

export const SAVE_STATE_CHANGED_EVENT = 'saveState:changed';

export function isSavingNow(): boolean {
  return saving;
}

export function startSaving(): void {
  if (saving) return;
  saving = true;
  document.dispatchEvent(
    new CustomEvent(SAVE_STATE_CHANGED_EVENT, { detail: { saving: true } })
  );
}

export function endSaving(): void {
  if (!saving) return;
  saving = false;
  document.dispatchEvent(
    new CustomEvent(SAVE_STATE_CHANGED_EVENT, { detail: { saving: false } })
  );
}
